module.exports = __webpack_public_path__ + "static/works-logo-5fd33aa0d6c2a464041ce9a3ba90cc42.png";